import React from "react";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";

/**
 *
 * @constructor
 */
export default function IngredientType() {
    // init
    const router = useRouter();
    const { t } = useTranslation();

    // init options
    const options = [
        {key: encodeURIComponent("!5fc28c0912799423591700"), value: t('allergen.free')},
        {key: "5fc28c0912799423591702", value: t('vegetarian')},
        {key: "5fc28c0912799423591701", value: t('vegan')},
        {key: encodeURIComponent("!5fc28c0912799423591703"), value: t('additive.free')},
    ];

    // render
    return (
        <div className="dropdown">
            <button className="form-control btn btn-outline-primary dropdown-toggle" type="button"
                    id="dropdownMenuButtonIngredientType" data-bs-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                {t('filter.products')}
            </button>
            <ul className="w-100 dropdown-menu" aria-labelledby="dropdownMenuButtonIngredientType">
                {options.map((option ) =>
                    <li key={option.key} className="dropdown-item">
                        <input className="form-check-input" type="checkbox" id={option.key} name={'it_' + option.key} defaultChecked={!!router.query['it_' + option.key]} />
                        <label className="ms-2 form-check-label" htmlFor={option.key}>{option.value}</label>
                    </li>
                )}
            </ul>
        </div>
    );
}